module.exports = __webpack_public_path__ + "assets/img/wealth.98fae6be.jpg";